import { useEffect, useRef } from 'react';

import {
  startChatSocket,
  subscribeChatEvents,
  subscribeChatReconnect,
} from '../lib/socket';
import type { ChatEvent } from './types';

/** Держать единый сокет чатов открытым, пока смонтирован вызывающий. */
export function useChatSocket(enabled = true) {
  useEffect(() => (enabled ? startChatSocket() : undefined), [enabled]);
}

/**
 * Подписка на события сокета. Обработчик берётся свежий на каждое событие —
 * пересоздавать подписку из-за смены замыкания не нужно.
 */
export function useChatEvents(handler: (event: ChatEvent) => void) {
  const ref = useRef(handler);
  useEffect(() => {
    ref.current = handler;
  });
  useEffect(() => subscribeChatEvents((event) => ref.current(event)), []);
}

/** Сокет переподключился — дочитать пропущенное. */
export function useChatReconnect(handler: () => void) {
  const ref = useRef(handler);
  useEffect(() => {
    ref.current = handler;
  });
  useEffect(() => subscribeChatReconnect(() => ref.current()), []);
}
